import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";

const PasswordReset = () => {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  let navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }
    axios.post("https://mygamename.com/php/update_password.php", {
      token: token,
      password: password,
    }).then((response) => {
      if (response.data == 'Password updated successfully.') {
        navigate('/login');
      } else {
        setMessage("Reset link is invalid or expired.");
      }
    });
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-[#1a1a1a] border border-[#222222] rounded-xl p-8">
        <h1 className="text-3xl font-extrabold text-[#F5F5F5] mb-2 tracking-tight">New password</h1>
        <p className="text-[#F5F5F5]/50 text-sm mb-8">Choose a strong password for your account.</p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-[#111111] border border-[#333333] text-[#F5F5F5] text-sm rounded-lg focus:ring-[#8B5CF6] focus:border-[#8B5CF6] block w-full p-3 pr-10 placeholder-[#F5F5F5]/30 outline-none transition-colors"
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F5F5F5]/30 hover:text-[#F5F5F5]/70 transition-colors"
            >
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>

          <div className="relative">
            <input
              type={showConfirm ? "text" : "password"}
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="bg-[#111111] border border-[#333333] text-[#F5F5F5] text-sm rounded-lg focus:ring-[#8B5CF6] focus:border-[#8B5CF6] block w-full p-3 pr-10 placeholder-[#F5F5F5]/30 outline-none transition-colors"
              required
            />
            <button
              type="button"
              onClick={() => setShowConfirm(!showConfirm)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F5F5F5]/30 hover:text-[#F5F5F5]/70 transition-colors"
            >
              {showConfirm ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>

          {message && (
            <p className="text-red-400 text-xs font-semibold">{message}</p>
          )}

          <button
            type="submit"
            className="w-full bg-[#8B5CF6] hover:bg-[#7C3AED] text-[#F5F5F5] font-semibold py-3 rounded-lg transition-colors mt-2"
          >
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordReset;
